<template>
  <div class="accordion" @click="toggleOpen">
    <div class="title">
      <div class="wrapper">
        <div class="h">Q.</div>
        <div class="body brown">{{ this.question }}</div>
        <div class="arrow">
          <img :class="{ open: open }" src="@/assets/img/walk/arrow.png" />
        </div>
      </div>
    </div>
    <div class="detail" :class="{ open: open }">
      <div class="wrapper">
        <div class="h">A.</div>
        <div class="body answer">
          <template v-for="(line, index) in this.details">
            <div class="image" :key="index" v-if="line.startsWith('img:')">
              <img :src="imagePath(line)" />
            </div>
            <div
              class="image"
              :key="index"
              v-else-if="line.startsWith('↑URL：')"
            >
              <a target="_blank" @click.stop="link(line)">{{ href(line) }}</a>
            </div>

            <router-link
              to="/faq/inquiry"
              v-else-if="line.startsWith('＜問い合わせボタン＞')"
              :key="index"
              @click.native="() => { trapTrackEvent(1) }"
            >
              <div class="button_wrapper">
                <div class="l_button__external">
                  <UIButton :label="'お問い合わせ'" />
                </div>
              </div>
            </router-link>
            <Atext
              :key="index"
              :line="line"
              :innerPageLink="innerPageLink"
              v-else
            />
            <!-- <span :key="index" v-html="line" v-else /> -->
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import UIButton from '@/components/UIButton'
import Atext from './Text'
import { FactoryTrack } from '@/constant/firebase'

export default {
  name: 'Accordion',
  components: {
    UIButton,
    Atext
  },
  props: ['question', 'ans', 'innerPageLink'],
  created() {
    this.imageNumber = 1
  },
  computed: {
    details: function() {
      return this.ans.split('<br>').map(item => `${item}<br>`)
    }
  },
  data() {
    return {
      open: false
    }
  },
  methods: {
    ...mapActions('Native', ['actionRequestExternalLink']),
    ...mapActions('Analytics', ['trackEvent']),
    trapTrackEvent(id) {
      switch (id) {
        case 1:
          this.trackEvent(FactoryTrack.createFAQInquiry())
          break
      }
    },
    toggleOpen() {
      this.open = !this.open
      this.imageNumber = 1
    },
    imagePath(filename) {
      const name = filename
        .replace('img:', '')
        .replace('<br>', '')
        .replace('.png', `-${this.imageNumber++}.png`)
      return require(`@/assets/img/walk/${name}`)
    },
    href(urlString) {
      return urlString.replace('↑URL：', '').replace('<br>', '')
    },
    url(urlString) {
      return urlString.replace('<br>', '')
    },
    link(url) {
      this.trackEvent(FactoryTrack.createExternalLink(url))
      this.actionRequestExternalLink(this.href(url))
      return false
    },
    forceOpen() {
      this.$el.scrollIntoView({ behavior: 'smooth' })
      this.imageNumber = 1
      if (!this.open) {
        this.open = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.button_wrapper {
  text-align: center;
  padding: 10px 0;
  .l_button__external {
    width: 250px;
    margin: 20px auto 0;
    display: inline-block;
  }
}

.accordion {
  padding: 10px 0;
  .title {
    font-weight: bold;
  }
  .detail {
    max-height: 0;
    opacity: 0;
    overflow-y: hidden;
    transition: all 0.35s;
    &.open {
      max-height: 2000px;
      opacity: 1;
      transition: all 0.35s;
    }
    .wrapper {
      align-items: baseline;
    }
  }

  .wrapper {
    display: flex;
    align-items: center;
    margin: 8px 4px;
    div {
      margin: 0 4px;
    }
    .h {
      font-weight: bold;
      max-width: 20px;
      color: #7e3f26;
    }
    .body {
      word-break: break-all;
      text-align: justify;
      flex-grow: 1;
      &.brown {
        color: #7e3f26;
      }
      div.image {
        text-align: center;
        padding: 20px 0;
        img {
          width: 100%;
        }
        a {
          text-decoration: underline;
        }
      }
      &.answer {
        padding-right: 10px;
      }
    }
    .arrow {
      max-width: 10px;
      display: flex;
      img {
        width: 100%;
        height: 100%;
        transition: all 0.35s;
        &.open {
          transform: rotate(180deg);
          transition: all 0.35s;
        }
      }
    }
  }
}

.close {
  display: none;
}
</style>
